function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M11.3,1.9C8.7-0.6,4.5-0.7,2,1.9c-2.6,2.6-2.6,6.7,0,9.3c2.6,2.6,6.8,2.6,9.4,0C13.9,8.7,13.9,4.5,11.3,1.9z  M10.5,10.3C9.8,11,9,11.4,8.1,11.7c-0.4,0.2-0.6,0.2-0.9,0.2c-0.1,0-0.1,0-0.2,0l-0.2,0c-0.2,0-0.2,0-0.5,0 c-1.3-0.1-2.5-0.6-3.4-1.5c-1-1-1.5-2.2-1.5-3.6c0-0.1,0-0.2,0-0.2c-0.1-0.3,0-0.7,0.1-1c0-0.1,0-0.1,0-0.2v0c0.2-1,0.7-1.8,1.4-2.5 c0.7-0.7,1.6-1.2,2.6-1.4c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0 c0.1,0,0.1,0,0.2,0H7c0,0,0,0,0.1,0c2.6,0.1,4.8,2.3,4.8,5v1.3C11.7,8.7,11.2,9.6,10.5,10.3z"
});

function SvgBall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13.3 13.3",
    style: {
      enableBackground: "new 0 0 13.3 13.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall);
export default __webpack_public_path__ + "static/media/ball.b432f204.svg";
export { ForwardRef as ReactComponent };